<template><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
  <path d="M23.94 14.83L12.13 2.49a1.53 1.53 0 0 0-2.24 0 1.7 1.7 0 0 0 0 2.35L20.56 16 9.89 27.16a1.7 1.7 0 0 0 0 2.35A1.53 1.53 0 0 0 11 30a1.59 1.59 0 0 0 1.14-.53l11.8-12.34a1.51 1.51 0 0 0 .47-1.13 1.64 1.64 0 0 0-.47-1.17z" fill="currentColor" />
</svg>
</template>